module.exports = __webpack_public_path__ + "img/banner-01.3eb88c02.jpg";